import { render, staticRenderFns } from "./setout.vue?vue&type=template&id=511c4765&scoped=true"
import script from "./setout.vue?vue&type=script&lang=js"
export * from "./setout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c4765",
  null
  
)

export default component.exports